import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, onyx} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  loadingBoxOrderingEntities: {
    height: 20,
    width: 120,
  },
  loadingBoxFQV: {
    height: 20,
    width: 110,
  },
  loadingBoxNewOrderingEntities: {
    height: 20,
    width: 70,
  },
  loadingBoxDaysRemaining: {
    height: 20,
    width: 90,
  },
  listItemText: {
    color: onyx,
  },
});
